<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="8" :sm="24">
            <a-form-item label="关键字">
              <a-input v-model="queryParam.keywords" placeholder="搜索模板名称"/>
            </a-form-item>
          </a-col>
          <a-col :md="!advanced && 6 || 24" :sm="24">
            <span class="table-page-search-submitButtons"
                  :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
              <a-button type="primary" @click="onSearch">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    
    <div class="table-operator">
      <a-button type="primary" icon="plus" @click="handleAdd">新建</a-button>
    </div>
    
    <s-table
            ref="table"
            size="default"
            :columns="columns"
            :data="loadData"
            :alert="{ show: true, clear: () => { this.selectedRowKeys = [] } }"
            :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
    >
      <span slot="action" slot-scope="text, record">
        <template>
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical"/>
          <a-popconfirm title="删除后不可恢复" @confirm="deleteExpressTpl(record)" okText="确定" cancelText="取消">
            <a href="javascript:;">删除</a>
          </a-popconfirm>
        </template>
      </span>
    </s-table>
    
    <a-modal
            title="操作"
            :width="1000"
            style="top: 20px; "
            v-model="visible"
            @ok="handleOk"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form">
          <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="名称"
                  hasFeedback
          >
            <a-input v-decorator="[
          'title',
          {rules: [{ required: true, message: '请输入名称' }]}
        ]" placeholder="请输入名称"/>
          
          </a-form-item>
          <!--          <a-form-item-->
          <!--                  label="包邮规则"-->
          <!--                  :labelCol="labelCol"-->
          <!--                  :wrapperCol="wrapperCol"-->
          <!--          >-->
          <!--            <a-radio-group v-model="formData.type">-->
          <!--              <a-radio :value="1">满元包邮</a-radio>-->
          <!--              <a-radio :value="2">满份包邮</a-radio>-->
          <!--            </a-radio-group>-->
          <!--            <PriceInput-->
          <!--                    :formData="formData"-->
          <!--                    field="price"-->
          <!--                    placeholder="请输入满多少元包邮，不填则不规则不生效" v-if="formData.type == 2"/>-->
          
          <!--            <a-input v-model="formData.num" type="number" placeholder="请输入满多少份包邮，不填则规则不生效" v-if="formData.type==2"/>-->
          <!--          </a-form-item>-->
          
          
          <a-table :columns="rulesColumns" :dataSource="formData.rules" :pagination="false"
                   :expandedRowKeys="expandedRowKeys" :scroll="{ y: 300 }" bordered>
            <template slot="area_keys" slot-scope="text,record,index">
              <div>{{areaKeys2String(text)}}</div>
              <a @click="handleSelectArea(record,index)">选择地区</a>
            </template>
            <template slot="start_amount" slot-scope="text,record">
              <a-input type="number" v-model="record.start_amount" placeholder="首件数量"/>
            </template>
            <template slot="start_price" slot-scope="text,record">
              <PriceInput
                      :formData="record"
                      field="start_price"
                      placeholder="首件价格"/>
            </template>
            <template slot="amount" slot-scope="text,record">
              <a-input type="number" v-model="record.amount" placeholder="续件数量"/>
            </template>
            <template slot="price" slot-scope="text,record">
              <PriceInput
                      :formData="record"
                      field="price"
                      placeholder="续件价格"/>
            </template>
            <template slot="custom_rule" slot-scope="text,record,index">
              <a-checkbox @change.prevent="customRuleSelect(index)" v-if="record.custom_rule ==0"></a-checkbox>
              <a-checkbox @change.prevent="customRuleChange(index)" v-if="record.custom_rule >0" checked></a-checkbox>
            </template>
            <template slot="action" slot-scope="text,record,index">
              <a-divider type="vertical"/>
              <a-popconfirm title="确定删除此条规则吗" @confirm="deleteRules(index)" okText="确定" cancelText="取消">
                <a href="javascript:;">删除</a>
              </a-popconfirm>
            </template>
            <template slot="expandedRowRender" slot-scope="record">
              <a-form-item
                      label="包邮条件"
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      v-if="record.custom_rule > 0"
              >
                <a-radio-group v-model="record.custom_rule">
                  <a-radio :value="1">件数</a-radio>
                  <a-radio :value="2">价格</a-radio>
                </a-radio-group>
                购买满
                <PriceInput
                        :formData="record"
                        field="custom_price"
                        placeholder="请输入满多少元包邮，不填则不规则不生效" v-if="record.custom_rule == 2"/>
                
                <a-input v-model="record.custom_num" type="number" placeholder="请输入满多少份包邮，不填则规则不生效"
                         v-if="record.custom_rule == 1"/>
                {{record.custom_rule == 1 ? '件': '元'}}包邮
              </a-form-item>
            </template>
            
            <template slot="title" slot-scope="text,record,index">
              配置规则
            </template>
            <template slot="footer" slot-scope="text,record,index">
              <a-button icon="plus" @click="addRules">新增地区</a-button>
            </template>
          </a-table>
        </a-form>
      </a-spin>
      
      <template slot="footer">
        <a-button key="cancel" @click="handleCancel">取消</a-button>
        <a-button key="forward" :loading="saveLoading" type="primary" @click="handleOk">保存</a-button>
      </template>
    </a-modal>
    
    <a-modal
            title="选择地区"
            :width="500"
            :bodyStyle="{'height':'300px','overflow-y': 'auto'}"
            v-model="areaVisible"
            @ok="handleAreaOk"
    >
      <!--<a-input-search style="margin-bottom: 8px" placeholder="搜索关键字" @change="onChange" />-->
      <!--<a-button type="primary" icon="plus" @click="areaTreeData[0].style.display=='none'?areaTreeData[0].style.display='':areaTreeData[0].style.display='none'" >操作</a-button>-->
      <a-tree
              checkable
              v-model="checkedAreaKeys"
              @check="areaTreeCheck"
              :defaultExpandedKeys="['']"
              :treeData="areaTreeData"
      >
        <template slot="title" slot-scope="record">
          <span>{{record.title}}-{{record.key}}</span>
        </template>
      </a-tree>
    </a-modal>
  </a-card>
</template>

<script>
    import STable from '@/components/table/'
    import ATextarea from 'ant-design-vue/es/input/TextArea'
    import AInput from 'ant-design-vue/es/input/Input'
    import moment from 'moment'
    import PriceInput from '@/components/PriceInput/'

    import {getAreaTree, getAreaHash, getAreaList, getAreaCount} from '@/api/utils'
    import {
        addExpressTpl,
        editExpressTpl,
        getExpressTplList,
        deleteExpressTpl,
        getExpressTplDetail
    } from '@/api/express'

    export default {
        name: 'ExpressTplList',
        components: {
            AInput,
            ATextarea,
            PriceInput,
            STable
        },
        data() {
            return {
                visible: false,
                areaVisible: false,
                saveLoading: false,
//        description: '全校班级管理。',
                innerData: [], // 嵌入表格数据
                areaHash: {},
                areaCountData: {},
                areaListData: [],
                areaTreeData: [],
                areaTreeDataOrig: [],
                checkedAreaKeys: [], //当前选择的地区
                allCheckedAreaKeys: [], //该目标全部选择的地区
                exressValue: 1,
                expandedRowKeys: [],
                formData: {
                    title: '',
                    rules: [],
                },
                currentRules: {},
                selectedKeys: [],
                labelCol: {
//          xs: { span: 24 },
//          sm: { span: 5 },
                    xs: {span: 24},
                    sm: {span: 2},
                },
                wrapperCol: {
                    xs: {span: 24},
                    sm: {span: 12},
                },
                form: this.$form.createForm(this),
                mdl: {},

                // 高级搜索 展开/关闭
                advanced: false,
                // 查询参数
                queryParam: {},
                groupOptions: [],
                // 表头
                columns: [
                    {
                        title: '#',
                        dataIndex: 'id',
                        width: '100px'
                    },
                    {
                        title: '名称',
                        dataIndex: 'title'
                    },
                    {
                        title: '创建时间',
                        dataIndex: 'create_time',
                        customRender: (text) => {
                            return moment(text * 1000).format('YYYY-MM-DD HH:mm:ss')
                        }
                    },
                    {
                        table: '操作',
                        dataIndex: 'action',
                        width: '150px',
                        scopedSlots: {customRender: 'action'},
                    }
                ],
                // 表头
                rulesColumns: [
                    {
                        title: '地区',
                        dataIndex: 'area_keys',
                        scopedSlots: {customRender: 'area_keys'}
                    },
                    {
                        title: '首件',
                        width: '100px',
                        dataIndex: 'start_amount',
                        scopedSlots: {customRender: 'start_amount'}
                    },
                    {
                        title: '运费(元)',
                        width: '100px',
                        dataIndex: 'start_price',
                        scopedSlots: {customRender: 'start_price'}
                    },
                    {
                        title: '续件',
                        width: '100px',
                        dataIndex: 'amount',
                        scopedSlots: {customRender: 'amount'}
                    },
                    {
                        title: '续费(元)',
                        width: '100px',
                        dataIndex: 'price',
                        scopedSlots: {customRender: 'price'}
                    },
                    {
                        title: '指定条件包邮',
                        width: '120px',
                        dataIndex: 'custom_rule',
                        align: 'center',
                        scopedSlots: {customRender: 'custom_rule'}
                    },
                    {
                        title: '操作',
                        dataIndex: 'action',
                        width: '120px',
                        scopedSlots: {customRender: 'action'},
                    }
                ],
                // 加载数据方法 必须为 Promise 对象
                loadData: parameter => {
                    console.log('loadData');
                    console.log(this.queryParam);
                    this.queryParam = Object.assign(this.queryParam, parameter)
                    return getExpressTplList(this.queryParam)
                        .then(res => {

                            return res.data
                        })
                },

                selectedRowKeys: [],
                selectedRows: [],
            }
        },
        computed: {},
        created() {
        },
        mounted() {
            let self = this;
            getAreaTree().then(res => {
                self.areaTreeDataOrig = res.data
            });
            getAreaHash().then(res => {
                self.areaHash = res.data
            });
            getAreaList().then(res => {
                self.areaListData = res.data
            });
            getAreaCount().then(res => {
                self.areaCountData = res.data
            });
        },
        methods: {
            // 指定条件包邮
            customRuleChange(index) {
                let self = this;
                self.formData.rules[index].custom_rule = 0;

            },
            customRuleSelect(index) {
                let self = this;
                self.formData.rules[index].custom_rule = 1;
            },

            addRules() {
                let self = this
                self.formData.rules.push({
                    'id': -(self.formData.rules.length + 1) + '',
                    'area_keys': [],
                    'start_price': 0,
                    'start_amount': 0,
                    'amount': 0,
                    'custom_rule': 0,
                    'custom_num': 0,
                    'custom_price': 0,
                })

                // 判断额外扩展的行
                self.formData.rules.map((val, index) => {
                    self.expandedRowKeys.push(index)
                })
            },
            deleteRules(index) {
                let self = this
                self.formData.rules.splice(index, 1)
            },

            handleSelectArea(record, index) {
                let self = this
                self.currentRules = record
                self.checkedAreaKeys = self.checkAreaKeysReFiler([...self.currentRules.area_keys])

                let areaTreeData = JSON.parse(JSON.stringify(self.areaTreeDataOrig))
//        let areaTreeData = [...self.areaTreeDataOrig]
//        console.log(areaList)
                self.formData.rules.map((rule, rindex) => {
                    if (rindex == index) {
                        return;//当前规则 不过滤地区
                    }

                    /* disabled 算法*/
                    /*rule.area_keys.map((area_key) =>{
                      if((area_key+'').substr(2,4) == '0000'){
                        //省级
                        areaTreeData.map(province =>{
                          if(province.key == area_key){
                            province.disabled = true;
                            return
                          }
                        });
                      }else if((area_key+'').substr(4,2) == '00'){
                        //市级
                        let province_key = (area_key+'').substr(0,2)+'0000';
                        areaTreeData.map(province =>{
                          if(province.key == province_key){
                            province.children.map(city =>{
                              if( city.key == area_key){
                                city.disabled = true
                                return
                              }
                            });
                            return
                          }
                        });
          
                      }else{
                        //县级
                        let province_key = (area_key+'').substr(0,2)+'0000'
                        let city_key = (area_key+'').substr(0,4)+'00'
                        areaTreeData.map(province =>{
                          if(province.key == province_key){
                            province.children.map(city =>{
                              if(city.key == city_key){
                                city.children.map(county =>{
                                  if(county.key == area_key){
                                    county.disabled = true
                                    return
                                  }
                                });
                                return
                              }
                            });
                            return
                          }
                        })
          
                      }
          
                    });*/

                    /*  过滤其他规则已选地区 */
                    rule.area_keys.map((area_key) => {
                        if ((area_key + '').substr(2, 4) == '0000') {
                            //省级
                            areaTreeData = areaTreeData.filter(province => {
                                return province.key != area_key
                            })
                        } else if ((area_key + '').substr(4, 2) == '00') {
                            //市级
                            let province_key = (area_key + '').substr(0, 2) + '0000';
                            areaTreeData.map(province => {
                                if (province.key == province_key) {
                                    province.children = province.children.filter(city => {
                                        return city.key != area_key
                                    });
                                    return
                                }
                            })

                        } else {
                            //县级
                            let province_key = (area_key + '').substr(0, 2) + '0000'
                            let city_key = (area_key + '').substr(0, 4) + '00'
                            areaTreeData.map(province => {
                                if (province.key == province_key) {
                                    province.children.map(city => {
                                        if (city.key == city_key) {
                                            city.children = city.children.filter(county => {
                                                return county.key != area_key
                                            });
                                            return
                                        }
                                    })
                                    return
                                }
                            })

                        }
                    })

                    /* 过滤没子节点的地区 */
                    areaTreeData = areaTreeData.filter((province, provinceIndex) => {
                        province.children = province.children.filter((city, cityIndex) => {
                            return city.children && city.children.length > 0
                        })
                        return province.children && province.children.length > 0
                    })

                })

                self.areaTreeData = [{
                    'title': '全部',
                    'key': '',
                    'value': '',
                    'parent_area_key': '-1',
                    "disabled": false,
                    "style": {
                        "display": ""
                    },
                    "scopedSlots": {
                        "title": "title",
                        "show": true
                    },
                    "children": [...areaTreeData]
                }]

                this.areaVisible = true
            },
            handleAreaOk() {
                let self = this
                self.currentRules.area_keys = self.checkAreaKeysFilter([...self.checkedAreaKeys])
                this.areaVisible = false
            },
            // 省市县选择过滤省市信息,全选子级的时候用父级替换所有子级
            checkAreaKeysFilter(checkedAreaKeys) {
                let self = this;
                let checkKeys = []
                if (checkedAreaKeys.lenth == 0) {
                    return []
                }
                let countyList = checkedAreaKeys.filter(area_key => {
                    //只留下县级
                    return (area_key + '').substr(4, 2) != '00' && (area_key + '') != ''
                });
                let provinceCount = {}
                let cityCount = {}

                //统计所选省市辖县数量
                countyList.map(area_key => {
                    let provinceKey = (area_key + '').substr(0, 2) + '0000'
                    if (provinceCount[provinceKey]) {
                        provinceCount[provinceKey]++
                    } else {
                        provinceCount[provinceKey] = 1
                    }

                    let cityKey = (area_key + '').substr(0, 4) + '00';
                    if (cityCount[cityKey]) {
                        cityCount[cityKey]++
                    } else {
                        cityCount[cityKey] = 1
                    }
                });

                //检测省的县级是否全选
                for (let provinceKey in provinceCount) {
                    if (provinceCount[provinceKey] == self.areaCountData.province[provinceKey]) {
                        //该省已选满了
                        checkKeys.push(provinceKey)
                        countyList = countyList.filter(countykey => {
                            //移出该省县级
                            return (countykey + '').substr(0, 2) != (provinceKey + '').substr(0, 2)
                        })
                        for (let cityKey in cityCount) {
                            //移出市级的统计数据
                            if ((cityKey + '').substr(0, 2) == (provinceKey + '').substr(0, 2)) {
                                delete cityCount[cityKey]
                            }
                        }
                    }
                }

                //检测市的县级是否全选
                for (let cityKey in cityCount) {
                    if (cityCount[cityKey] == self.areaCountData.city[cityKey]) {
                        //该市已选满了
                        checkKeys.push(cityKey)
                        countyList = countyList.filter(countykey => {
                            //移出该市县级
                            return (countykey + '').substr(0, 4) != (cityKey + '').substr(0, 4)
                        })
                    }
                }

                return checkKeys.concat(countyList)
            },
            // 从rule到选择器,节点还原
            checkAreaKeysReFiler(areaKeys) {
                let self = this;
                if (areaKeys.length == 0) {
                    return []
                }
                let checkedAreaKeys = [...areaKeys]

                areaKeys.map((area_key) => {
                    let countyList = []
                    if ((area_key + '').substr(2, 4) == '0000') {
                        //省级
                        self.areaListData.map(county => {
                            //该省级下所有县级
                            if ((county.key + '').substr(0, 2) == (area_key + '').substr(0, 2) && (county.key + '').substr(4, 2) != '00') {
                                countyList.push(county.key)
                            }
                        })
                    } else if ((area_key + '').substr(4, 2) == '00') {
                        //市级
                        self.areaListData.map(county => {
                            //该市级下所有县级
                            if ((county.key + '').substr(0, 4) == (area_key + '').substr(0, 4) && (county.key + '').substr(4, 2) != '00') {
                                countyList.push(county.key)
                            }
                        })
                    }
                    checkedAreaKeys = checkedAreaKeys.concat(countyList)
                })
                console.log('还原节点')
                console.log(checkedAreaKeys)
                return checkedAreaKeys
            },
            areaTreeCheck(checkedKeys, e) {
                console.log(checkedKeys)
                console.log(e)
            },
            // 增
            handleAdd() {
                this.visible = true
                this.form.resetFields()
                this.formData = {
                    id: 0,
                    title: '',
                    rules: []
                }
            },
            handleCancel() {
                this.visible = false
            },
            // 改
            handleEdit(record) {
                let self = this
                getExpressTplDetail({id: record.id}).then(res => {
                    self.form.setFieldsValue({...res.data})
                    self.formData.id = record.id
                    self.formData.title = res.data.title
                    self.formData.rules = res.data.rules

                    res.data.rules.map((val, index)=> {
                        self.expandedRowKeys.push(index)
                    })
                })
                // console.log(this.mdl)
                this.visible = true
            },

            // 增改 处理
            handleOk(e) {
                let self = this
                e.preventDefault()
                this.form.validateFields((err, values) => {
                    if (!err) {
                        console.log('Received values of form: ', values)
                        console.log('Received valuess of formData: ', self.formData)
                        self.saveLoading = true
                        if (self.formData.id) {
                            editExpressTpl(Object.assign(self.formData, values)).then(res => {
                                self.$message.success('修改成功')
                                self.$refs.table.refresh(true)
                                self.visible = false
                                self.saveLoading = false
                            }).catch(err => {
                                self.$message.error(err.data.msg)
                                self.saveLoading = false
                            })
                        } else {
                            addExpressTpl(Object.assign(self.formData, values)).then(res => {
                                self.$message.success('新增成功')
                                self.$refs.table.refresh(true)
                                self.visible = false
                                self.saveLoading = false
                            }).catch(err => {
                                self.$message.error(err.data.msg)
                                self.saveLoading = false
                            })
                        }
                    }
                })
            },
            // 查
            onSearch() {
                let self = this
                self.$refs.table.refresh(true)
            },
            // 删
            deleteExpressTpl(record) {
                let self = this
                deleteExpressTpl({id: record.id}).then(res => {
                    self.$message.success('删除成功')
                    self.$refs.table.refresh(true)
                }).catch(err => {
                    self.$message.error(err.data.msg)
                })
            },
            onSelectChange(selectedRowKeys, selectedRows) {
                this.selectedRowKeys = selectedRowKeys
                this.selectedRows = selectedRows
            },
            areaKeys2String(area_keys) {
                let self = this
                let names = area_keys.map(area_key => {
                    return self.areaHash[area_key] || ''
                })
                return names.join(',')
            }
        },
        watch: {
            /*
            'selectedRows': function (selectedRows) {
              this.needTotalList = this.needTotalList.map(item => {
                return {
                  ...item,
                  total: selectedRows.reduce( (sum, val) => {
                    return sum + val[item.dataIndex]
                  }, 0)
                }
              })
            }
            */
        }
    }
</script>
<style>
  .ant-table-expanded-row input {
    width: 80px;
    margin: 0 10px;
  }
</style>